
import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import { Route } from "react-router-dom";
import AnexoVForm from "./components/form/AnexoVForm";
//import PresentacionList from "./components/list/AnexoIList";
 
const AnexoVPage = () => {
  let { path } = useRouteMatch();
  return (
    <Switch>
      {/*<Route exact path={`${path}/`} component={ PresentacionList } />*/}
      <Route exact path={`${path}/new/:cuit`} component={ AnexoVForm } />
      <Route exact path={`${path}/edit/:cuit`} component={ AnexoVForm } />
    </Switch>
  );
}

export default AnexoVPage;